import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import type { RouteContributionDefinition } from '@ochal/module-sdk/contracts';
import type { PluginRuntime } from '@ochal/plugin-runtime';
import { getLazyComponent } from '@ochal/react-runtime';
import { ProtectedRoute } from './components/protected-route';
import { LoginPage } from './pages/login-page';
import { ForbiddenPage, MaintenancePage, NotFoundPage, RouteErrorPage, SessionExpiredPage } from './pages/system-pages';
import { fa } from './i18n/fa';

const AdminLayout = lazy(() => import('./components/admin-layout').then((module) => ({ default: module.AdminLayout })));
const shellFallback = <main className="loading-page" aria-busy="true" aria-label={fa.state.checkingSession} />;

export function createAppRouter(runtime: PluginRuntime) {
  const moduleRoutes = runtime.contributions.list('route') as readonly RouteContributionDefinition[];
  return createBrowserRouter([
    { path: '/login', element: <LoginPage/> },
    { path: '/session-expired', element: <SessionExpiredPage/> },
    { path: '/maintenance', element: <MaintenancePage/> },
    { path: '/403', element: <ProtectedRoute><ForbiddenPage/></ProtectedRoute> },
    { path: '/404', element: <ProtectedRoute><NotFoundPage/></ProtectedRoute> },
    {
      path: '/', element: <ProtectedRoute><Suspense fallback={shellFallback}><AdminLayout/></Suspense></ProtectedRoute>, errorElement: <RouteErrorPage/>,
      children: [
        ...moduleRoutes.map((route) => { const Component = getLazyComponent(runtime, route.id); return { path: route.path === '/' ? undefined : route.path.slice(1), index: route.path === '/', element: <ProtectedRoute permission={route.permission} featureFlag={route.featureFlag}><Component/></ProtectedRoute> }; }),
        { path: '*', element: <NotFoundPage/> },
      ],
    },
  ]);
}
